import campaignsJson from '../../demo/fixtures/campaigns.json'
import fixtureJson from '../../demo/fixtures/partnership.json'
import chainStepsJson from '../../demo/fixtures/chain-steps.json'
import { formatPercent, formatUsd } from '../../demo/format'
import type { W8PartnershipTier } from '../../demo/store'

interface TierFixture {
  key: W8PartnershipTier
  name: string
  monthlyQuota: number
  recommended: boolean
}

function fill(template: string, values: Record<string, string>): string {
  return Object.entries(values).reduce((result, [key, value]) => result.replaceAll(`{${key}}`, value), template)
}

const fixture = fixtureJson as Omit<typeof fixtureJson, 'tiers'> & { tiers: TierFixture[] }
const recommendedTiers = fixture.tiers.filter((tier) => tier.recommended)
const recommendedTier = recommendedTiers[0]
if (!recommendedTier) throw new Error('Partnership fixture must contain one recommended tier')

if (import.meta.env.DEV) {
  const campaign = campaignsJson.campaigns.find((item) => item.id === fixture.task.campaignId)
  const product = campaignsJson.products.find((item) => item.id === campaign?.productId)
  const renderedRatio = fixture.current.used / fixture.current.monthlyQuota
  if (campaign?.spendMonth !== fixture.current.used) throw new Error('Partnership used quota must match c-mug-us spendMonth')
  if (Math.abs(renderedRatio - fixture.current.usedRatio) > 0.000_51) throw new Error('Partnership usedRatio must match used / monthlyQuota')
  if (recommendedTiers.length !== 1) throw new Error('Partnership fixture must contain exactly one recommended tier')
  if (!product?.name.includes(fixture.task.productShortName)) throw new Error('Partnership task label must identify the fixture product')
}

const quota = formatUsd(recommendedTier.monthlyQuota)
const product = fixture.task.productShortName

export const partnershipData = {
  ...fixture,
  stepSubtitle: chainStepsJson.steps.find((step) => step.id === '02')?.pptName ?? '',
  recommendedTier,
  tiers: fixture.tiers.map((tier) => ({
    ...tier,
    unit: fill(fixture.copy.tierUnit, { quota: formatUsd(tier.monthlyQuota) }),
  })),
  detailLead: fill(fixture.copy.detailLead, { name: recommendedTier.name }),
  detailBody: fill(fixture.copy.detailBody, { quota }),
  quotaTitle: fill(fixture.copy.quotaTitle, { product }),
  quotaValue: `${formatUsd(fixture.current.used)} / ${formatUsd(fixture.current.monthlyQuota)}`,
  quotaNote: fill(fixture.copy.quotaNote, { ratio: formatPercent(fixture.current.usedRatio) }),
  confirmToast: fill(fixture.copy.confirmToast, { name: recommendedTier.name, product, quota }),
}
